<div>
  <div>
    <ng-container [ngSwitch]="errorCode">
      <ng-container *ngSwitchCase="errorCodes.LoginFailed">
        <p class="header">We're sorry, an error has occurred.</p>
        <p class="help-text">An error has occurred. Please close the tab and try again. If the error persists, please call Provider Services at <a href="tel:+18669181595">1-866-918-1595</a> to report the problem.</p>
      </ng-container>
      <ng-container *ngSwitchCase="errorCodes.NotFound">
        <p class="header">We're sorry, we can't seem to find the page you're looking for.</p>

        <p class="sub-header">Here are some helpful links instead:</p>
        <ul>
          <li><a routerLink="/" id="errorPageHomeLink">Home</a></li>
          <li><a routerLink="/member-look-up" id="errorPageMemberLookUpLink">Member Look Up</a></li>
        </ul>

        <p class="help-text">Please close the tab and select the function again or call Provider Services at <a href="tel:+18669181595">1-866-918-1595</a> to report this problem if it persists.</p>
      </ng-container>
    </ng-container>    
  </div>
</div>
